<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 底部信息 -->
      <div class="footer-info">
        <div class="copyright">
          © {{ currentYear }} trasok.com
        </div>
        <div class="icp">
          <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
          >
            鄂ICP备2026008283号-1
          </a>
        </div>
      </div>
    </div>
    <!-- 顶部流光扫描线 -->
    <span class="scan-line" />
  </footer>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  /* 深科技蓝渐变,与导航/横幅同族 */
  background:
      radial-gradient(120% 200% at 50% 0%, rgba(42, 74, 184, 0.35) 0%, transparent 60%),
      linear-gradient(180deg, #0b1538 0%, #162663 100%);
  border-top: 1px solid rgba(120, 170, 255, 0.22);
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

/* 顶部霓虹高光线 */
.footer::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 1px;
  background: linear-gradient(90deg,
  transparent,
  rgba(79, 209, 255, 0.9),
  rgba(79, 141, 255, 0.9),
  transparent);
  opacity: 0.85;
}

/* 底部流光扫描线 */
.scan-line {
  position: absolute;
  bottom: 0; left: 0;
  width: 30%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #4fd1ff, transparent);
  filter: blur(1px);
  animation: scan 7s linear infinite;
  opacity: 0.8;
}
@keyframes scan {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(430%); }
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 8px 20px;
  position: relative;
  z-index: 1;
}

.footer-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: rgba(190, 210, 255, 0.72);
}

.footer-info a {
  position: relative;
  color: rgba(190, 210, 255, 0.72);
  text-decoration: none;
  transition: color 0.3s ease, text-shadow 0.3s ease;
}

.footer-info a:hover {
  color: #4fd1ff;
  text-shadow: 0 0 10px rgba(79, 209, 255, 0.8);
}

/* 悬停时在链接下方出现一条霓虹细线 */
.footer-info a::after {
  content: '';
  position: absolute;
  left: 0; right: 0; bottom: -3px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #4fd1ff, transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.footer-info a:hover::after {
  opacity: 1;
}

.copyright,
.icp,
.beian {
  display: inline-flex;
  align-items: center;
}

.beian img {
  height: 16px;
  margin-right: 5px;
}

/* 响应式 */
@media (max-width: 768px) {
  .footer-container { padding: 22px 16px; }
  .footer-info {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

/* 尊重降低动效偏好 */
@media (prefers-reduced-motion: reduce) {
  .scan-line { animation: none; }
  * { transition: none !important; }
}
</style>